import { IOption } from 'types/fields';

/* istanbul ignore next */
export const isOptionEqualToValue = (
	option: IOption,
	value: string | IOption
) => option.value === ((value as IOption).value || value);

export const sortOptions = (a: IOption, b: IOption) =>
	a.label.localeCompare(b.label);
